import React from "react";
import Layout from "layouts";
import OrderComponent from "./OrderComponent.js";

export default function Orders() {
  return (
    <Layout breadCrumb={[{ label: "All Orders", to: "#" }]}>
      <OrderComponent />
    </Layout>
  );
}
